// extracted by mini-css-extract-plugin
export default {"imageContainer":"C3-z","summaryPar":"D3-z","ratingCategories":"E3-z","reviewerInfo":"F3-z","reviewTypes":"G3-z","expanded":"H3-z"};